import { Dialog } from "@headlessui/react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import CancelButton from "../../../../components/CancelButton";
import SaveButton from "../../../../components/SaveButton";
import MaterialTableEmpReportsTo from "../../../../components/tables/MaterialTableEmpReportsTo";
import { associatedEmployeeId, fromEmpReportsModal } from "../atoms/atoms";
import { useGetEmployeeReportsToByOfficeCode } from "../hooks/useGetEmployeeReportsToByOfficeCode";

interface EmployeeReportsToModalProps {
  officeCode: string | null | undefined;
  showEmployeeReportsTo: boolean;
  closeReportsToModal: () => void;
  setSaveModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const EmployeeReportsToModal: React.FC<EmployeeReportsToModalProps> = ({
  officeCode,
  showEmployeeReportsTo,
  closeReportsToModal,
  setSaveModal,
}) => {
  const { data: empReportsToData, isLoading: isFetching } =
    useGetEmployeeReportsToByOfficeCode(officeCode);
  const [selectedEmployee, setSelectedEmployee] =
    useRecoilState(associatedEmployeeId);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [, setFromEmployeeReportsTo] = useRecoilState(fromEmpReportsModal);

  useEffect(() => {
    setSelectedRows([]);
    setSelectedEmployee([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    //removes tableData
    const rowsToUpdate = rows.map((r) => {
      const { tableData, ...rows } = r;
      return rows;
    });
    setSelectedRows(rowsToUpdate);
  };
  const handleSubmit = () => {
    const associatedEmployeeId = selectedRows.map((row) => row.employeeId);
    setSelectedEmployee(associatedEmployeeId);
    setFromEmployeeReportsTo(true);
    setSaveModal(true);
    closeReportsToModal();
    setSelectedRows([]);
  };

  const matColumns = [
    { title: "Name", field: "name" },
    { title: "Title", field: "title" },
    { title: "Reports To", field: "reportsTo" },
    { title: "Reports To Office Code", field: "reportsToOfficeCode" },
  ];

  return (
    <>
      <Dialog
        open={showEmployeeReportsTo}
        onClose={closeReportsToModal}
        className="fixed z-20 inset-0 overflow-y-auto"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
          <div className="flex min-h-screen items-center justify-center p-4">
            <Dialog.Panel
              className="border-primary border-l-6 py-4 px-6 overflow-visible  
              text-left align-middle transition-all 
              transform bg-white shadow-xl brContainer reportsToModalWidth"
            >
              <div className="text-lg text-gray-500 font-bold">Employee</div>
              <div className="text-base text-primary font-bold">
                Please select the Employees included in the update.
              </div>
              <div className="h-1 w-full border-b-4 border-secondary mt-3 mb-2" />
              {selectedRows.length > 0 && (
                <div className="text-sm text-primary">
                  Selected Employee/s
                  <p className="inline-block font-bold ml-1">
                    ({selectedRows.length})
                  </p>
                </div>
              )}
              <div
                className={`mt-2 box-shadow ${
                  empReportsToData?.length > 6
                    ? `w-auto h-80 overflow-auto`
                    : ``
                }`}
              >
                <MaterialTableEmpReportsTo
                  data={empReportsToData}
                  columns={matColumns}
                  isLoading={isFetching}
                  paging={true}
                  onSelectionChange={handleSelectedRowsChange}
                  selectedRows={selectedRows}
                  selection={true}
                />
              </div>
              <div className="flex justify-end mt-3 mr-1">
                <SaveButton
                  className={"mr-2"}
                  onClick={() => {
                    handleSubmit();
                  }}
                />

                <CancelButton
                  onClick={() => {
                    closeReportsToModal();
                  }}
                />
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default EmployeeReportsToModal;
